<template>
    <section id="mainContainer">
        <adminHeader></adminHeader>
        <section class="admin-mid-container">
            <div class="admin-custom-row admin-page-row" id="leftMenuSlideBox">
                <adminNavigation></adminNavigation>
                <section class="admin-right-sidebar">
                    <div class="admin-right-sidebar-in">
                        <div class="admin-right-sidebar-in-top">
                            <div class="admin-custom-row">
                                <div class="admin-right-sidebar-in-top-left">
                                    <h1>
                                        {{ constants.JOIN_OUR_TEAM_TEXT }}
                                    </h1>
                                    <div class="admin-page-type-links">
                                        <ul>
                                            <li>
                                                <a id="allLink" href="#" :class="{ active: activeTab === 'all' }"
                                                    @click="switchView('all')">
                                                    {{ constants.ALL_LINK }}
                                                    <span>{{ counts.all }}</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a id="newApplicationLink" href="#"
                                                    :class="{ active: activeTab === 'newApplication' }"
                                                    @click="switchView('newApplication')">
                                                    {{ constants.NEW_APPLICATION_LINK }}
                                                    <span>{{ counts.newApplication }}</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a id="followUpLink" href="#"
                                                    :class="{ active: activeTab === 'followUp' }"
                                                    @click="switchView('followUp')">
                                                    {{ constants.FOLLOW_UP_LINK }}
                                                    <span>{{ counts.followUp }}</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a id="rejectedLink" href="#"
                                                    :class="{ active: activeTab === 'rejected' }"
                                                    @click="switchView('rejected')">
                                                    {{ constants.REJECTED_LINK }}
                                                    <span>{{ counts.rejected }}</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a id="hiredLink" href="#" :class="{ active: activeTab === 'hired' }"
                                                    @click="switchView('hired')">
                                                    {{ constants.HIRED_LINK }}
                                                    <span>{{ counts.hired }}</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="admin-right-sidebar-in-top-right">
                                    <div class="admin-right-sidebar-in-top-right-top">
                                        <div class="admin-search-box">
                                            <input id="seachJoinTeamInput" type="text" placeholder="Search"
                                                v-model="searchedText"
                                                @keyup.enter="fetchJoinTeams(activeTab), fetchCounts(searchedText), editFormSubmitted = false, selectAll = false, selectedJoinTeams = []" />
                                        </div>
                                    </div>
                                    <div class="admin-right-sidebar-in-top-right-btm">
                                        <!-- v-if="selectedJoinTeams.length > 1"> -->
                                        <div class="tags">
                                            <ul>
                                                <li v-if="selectedJoinTeams.length > 1">
                                                    <span>{{ selectedJoinTeams.length }} entries selected</span>
                                                    <button id="tagCloseBtn"
                                                        @click="selectedJoinTeams = [], selectAll = false"></button>
                                                </li>
                                                <li v-if="dateFilter === 'custom'">
                                                    <span>{{formatCustomDate(startDate) }}-{{ formatCustomDate(endDate)
                                                        }}</span>
                                                    <button id="tagCloseBtn"
                                                        @click="dateFilter = '', fetchJoinTeams(activeTab), fetchCounts(), limit = 10"></button>
                                                </li>
                                                <li v-if="dateFilter === 'lastWeek'">
                                                    <span>Last Week </span>
                                                    <button id="tagCloseBtn"
                                                        @click="dateFilter = '', fetchJoinTeams(activeTab), fetchCounts(), limit = 10"></button>
                                                </li>
                                                <li v-if="dateFilter === 'lastMonth'">
                                                    <span>Last Month</span>
                                                    <button id="tagCloseBtn"
                                                        @click="dateFilter = '', fetchJoinTeams(activeTab), fetchCounts(), limit = 10"></button>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="delete-all-btn-link" v-if="selectedJoinTeams.length > 1">
                                            <button class="btn_link" id="deleteAllBtn" data-bs-toggle="modal"
                                                data-bs-target="#deletePop" @click="setDeleteMode('all')">{{
                                                    constants.DELETE_ALL_BUTTON }}</button>
                                        </div>
                                        <div class="delete-all-btn-link" v-if="selectedJoinTeams.length > 1">
                                            <button class="btn_link" id="downloadAllBtn"
                                                @click="downloadResume('all')">{{
                                                    constants.DOWNLOAD_ALL_BUTTON }}</button>
                                        </div>
                                        <div class="date-filter-box" id="dateFilterDropdown"
                                            :class="{ 'show-date-dropdown': showDateDropdown }">
                                            <div class="date-filter-icon">
                                                <button id="dateFilterBtn" @click="showDateDropdown = true"><img
                                                        src="@/assets/images/admin-img/date-blue.svg" alt="" /></button>
                                            </div>
                                            <div class="date-filter-dropdown"
                                                :class="{ 'show-custom-date': showCustomDate }">
                                                <div class="date-filter-dropdown-in">
                                                    <a href="#" id="lastWeeekLink" class="date-item"
                                                        @click="getDateFilteredData('lastWeek')">{{
                                                            constants.LAST_WEEK_LINK }}</a>
                                                    <a href="#" id="lastMonthLink" class="date-item"
                                                        @click="getDateFilteredData('lastMonth')">{{
                                                            constants.LAST_MONTH_LINK }}</a>
                                                    <a href="#" id="customDateLink"
                                                        @click.prevent="showCustomPicker = true; showCustomDate = true">{{
                                                            constants.CUSTOM_DATE_LINK }}</a>
                                                </div>
                                                <!-- <div class="custom-date-picker">
                                                    <Datepicker v-if="showCustomPicker" range
                                                        :enable-time-picker="false" :clearable="false"
                                                        menu-class-name="custom-datepicker-menu" :inline="true"
                                                        @range-start="onRangeStart" @range-end="onRangeEnd">
                                                        <template #action-buttons>
                                                            <div class="action-buttons">
                                                                <button class="apply-btn"
                                                                    @click="handleDate()">Apply</button>
                                                                <button id="cancelButton" class="cancel-btn"
                                                                    @click="resetClasses">Cancel</button>
                                                            </div>
                                                        </template>
                                                    </Datepicker>

                                                </div> -->
                                                <div class="custom-date-picker">
                                                    <Datepicker v-if="showCustomPicker" range
                                                        :enable-time-picker="false" :clearable="false"
                                                        menu-class-name="custom-datepicker-menu" :inline="true"
                                                        @range-start="onRangeStart" @range-end="onRangeEnd">
                                                        <template #action-buttons>
                                                            <div class="action-buttons">
                                                               
                                                                <button id="cancelButton" class="cancel-btn"
                                                                    @click="resetClasses">{{ constants.CANCEL_BUTTON }}</button>
                                                                    <button id="doneButton" class="apply-btn"
                                                                    @click="handleDate()"> {{ constants.DONE_BUTTON }}</button>
                                                            </div>
                                                        </template>
                                                    </Datepicker>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div :class="['admin-item-list-section admin-join-team-section', { 'show-edit-item-outer': editFormSubmitted }]"
                            v-if="editJoinTeamsData.length > 0">
                            <div class="admin-item-list-section-in" ref="scrollWrapper" data-simplebar>
                                <div class="admin-item-list-section-scroll">
                                    <div class="admin-item-list-top">
                                        <div class="admin-item-list-row">
                                            <div class="admin-item-checkbox">
                                                <div class="admin-checkbox-input">
                                                    <input name="cssCheckbox" id="selectAll" type="checkbox"
                                                        class="css-checkbox" @change="toggleSelectAll"
                                                        :checked="selectAll === true">
                                                    <label for="selectAll"></label>
                                                </div>
                                            </div>

                                            <div class="admin-item-image">
                                                {{ constants.IMAGE_LABEL }}
                                            </div>

                                            <div class="admin-item-team-name">
                                                {{ constants.NAME_LABEL }}
                                            </div>

                                            <div class="admin-item-team-email">
                                                {{ constants.EMAIL_LABEL }}
                                            </div>

                                            <div class="admin-item-join-team-designation">
                                                {{ constants.DESIGNATION_LABEL }}
                                            </div>
                                            <div class="admin-item-team-reference">
                                                {{ constants.NAME_OF_REFERENCE_LABEL }}
                                            </div>

                                            <div class="admin-item-team-join-description">
                                                {{ constants.DESCRIPTION_LABEL }}
                                            </div>

                                            <div class="admin-item-team-status">
                                                {{ constants.STATUS_LABEL }}
                                            </div>

                                            <div class="admin-item-team-date">
                                                {{ constants.DATE_LABEL }}
                                            </div>

                                            <div class="admin-item-actions">
                                                {{ constants.ACTIONS_LABEL }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="admin-item-list-btm">
                                        <div ref="sortableList">

                                        <div v-for="(joinTeam, index) in editJoinTeamsData" :key="joinTeam.id"
                                            :class="['admin-item-box', { 'show-edit-item': editFormSubmitted }]">
                                            <div class="admin-item-box-top">
                                                <div class="admin-item-list-row">
                                                    <!-- <div class="new-message-point"></div> -->
                                                    <div class="admin-item-checkbox">
                                                        <div class="admin-checkbox-input">
                                                            <input name="cssCheckbox" :id="'demo_opt_' + joinTeam.id"
                                                                type="checkbox" class="css-checkbox"
                                                                @change="toggleJoinTeamSelection(joinTeam.id)"
                                                                :checked="selectedJoinTeams.includes(joinTeam.id)">
                                                            <label :for="'demo_opt_' + joinTeam.id"></label>
                                                        </div>
                                                    </div>

                                                    <div class="admin-item-image">
                                                        <div class="sm-img"><img :src="getCdnImageAddress(joinTeam.candidateImage, `w_40,h_41/`)"
                                                                alt="" />
                                                        </div>
                                                    </div>

                                                    <div class="admin-item-team-name">
                                                        <div class="limited-text text-limit">{{ joinTeam.candidateName
                                                            }}</div>
                                                    </div>

                                                    <div class="admin-item-team-email">
                                                        {{ joinTeam.email }}
                                                    </div>

                                                    <div class="admin-item-join-team-designation text-limit">
                                                        {{ joinTeam.designation }}
                                                    </div>


                                                    <div class="admin-item-team-reference">
                                                        {{ joinTeam.nameOfReference }}
                                                    </div>
                                                    <div class="admin-item-team-join-description text-limit">
                                                        {{ joinTeam.description }}
                                                    </div>
                                                    <div class="admin-item-team-status">
                                                        <div class="status-select-box">
                                                            <select id="statusSelectBox" class="statusselectbox"
                                                                @change="onStatusChange"
                                                                :style="getStatusColor(joinTeam.status)"
                                                                @click="personId(joinTeam.id)">
                                                                <option value="new" :selected="joinTeam.status === 0">
                                                                    New</option>
                                                                <option value="followup"
                                                                    :selected="joinTeam.status === 1">Follow up</option>
                                                                <option value="hired" :selected="joinTeam.status === 3">
                                                                    Hired</option>
                                                                <option value="rejected"
                                                                    :selected="joinTeam.status === 4">Rejected</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="admin-item-team-date">
                                                        <!-- <span v-b-tooltip.up :title="formatDate(joinTeam.Created_at)"
                                                            data-bs-toggle="tooltip">
                                                            {{ joinTeam.relativePostDate }}</span> -->
                                                        <span
                                                            v-b-tooltip.up="{ title: formatDate(joinTeam.Created_at) }"
                                                            v-if="joinTeam.Created_at">
                                                            {{ formatDate(joinTeam.Created_at) }}
                                                        </span>
                                                    </div>
                                                    <div class="admin-item-actions">
                                                        <ul class="admin-action-link">

                                                            <li>
                                                                <button class="hide-row-btn" id="joinTeamPgDeleteBtn" data-bs-toggle="modal"
                                                                    data-bs-target="#deletePop"
                                                                    @click="setDeleteMode('single', joinTeam.id)">
                                                                    {{ constants.DELETE_BUTTON }}
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <button id="joinTeamPgDwonloadBtn"
                                                                    @click="downloadResume('single', joinTeam.id, joinTeam.candidateName)">
                                                                    {{ constants.DOWNLOAD_BUTTON }}
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <button id="teamPgPublishBtn" class="viewbtn"
                                                                    @click="dummyfunction(index, joinTeam.id, joinTeam.email)">
                                                                    {{ constants.VIEW_BUTTON }}
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="admin-item-box-btm join-team-details" v-if="joinTeam.editing">
                                                <div class="join-team-details-box">
                                                    <button class="viewclose" id="viewCloseBtn"
                                                        @click="editFormSubmitted = false"><img
                                                            src="@/assets/images/admin-img/tags-close-icon.svg"
                                                            alt="" /></button>
                                                    <div class="join-team-details-top">
                                                        <div class="join-team-details-top-left">
                                                            <div class="join-team-details-top-img">
                                                                <img :src="editimageSrc || require('@/assets/images/admin-img/image-icon.svg')" alt="" />
                                                            </div>
                                                            <div class="join-team-details-top-left-content">
                                                                <h3>{{ joinTeam.candidateName }}</h3>
                                                                <span>{{ joinTeam.designation }}</span>
                                                            </div>
                                                        </div>
                                                        <div class="join-team-details-top-right">
                                                            <div class="mail-text-row">
                                                                <label>
                                                                    {{ constants.EMAIL_LABEL }}</label>
                                                                <div class="mail-text-desc">
                                                                    {{ joinTeam.email }}
                                                                </div>
                                                            </div>
                                                            <div class="mail-text-row">
                                                                <label>{{ constants.NAME_OF_REFERENCE_LABEL }}</label>
                                                                <div class="mail-text-desc">
                                                                    {{ joinTeam.nameOfReference }}
                                                                </div>
                                                            </div>
                                                            <div class="mail-text-row">
                                                                <label>{{ constants.DESCRIPTION_LABEL }}</label>
                                                                <div class="mail-text-desc">
                                                                    {{ joinTeam.description }}
                                                                </div>
                                                            </div>
                                                            <div class="mail-actions">
                                                                <div class="attachment-box">
                                                                    <i>
                                                                        <img src="@/assets/images/admin-img/pdf-icon.svg"
                                                                            alt="" />
                                                                    </i>
                                                                    <div class="attachment-info">
                                                                        <span>{{ joinTeam.resumeName }}</span>
                                                                        <span>{{ joinTeam.resumeSize }}</span>
                                                                    </div>
                                                                    <button class="attachmentDownloadBtn"
                                                                        @click="downloadResume('single', joinTeam.id)">
                                                                        <img src="@/assets/images/admin-img/download-icon.svg"
                                                                            alt="" />
                                                                    </button>
                                                                </div>
                                                                <ul class="mail-ul-actions">
                                                                    <li>
                                                                        <button id="replyMailBtn" data-bs-toggle="modal"
                                                                            data-bs-target="#replyPop"
                                                                            @click="candidateId = joinTeam.id, errMsg = ''">
                                                                            {{ constants.REPLY_BUTTON }}</button>
                                                                    </li>
                                                                    <li>
                                                                        <button id="deleteMailBtn"
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#deletePop"
                                                                            @click="setDeleteMode('single', joinTeam.id)">
                                                                            {{ constants.DELETE_BUTTON }}</button>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="reply-list-row">
                                                        <!-- <div class="reply-list-box">
                                                                 <div class="reply-list-img">
                                                                    <img src="@/assets/images/admin-img/demo-img/item-img-11.jpg" alt="" />
                                                                 </div>
                                                                 <div class="reply-list-content">
                                                                    <strong>Darlene Robertson <span>2 <script>display("DAYS_TEXT");</script> <script>display("AGO_TEXT");</script></span></strong>
                                                                    <div class="mail-text-row">
                                                                      
                                                                        <div class="mail-text-desc">
                                                                            I will update tomorrow
                                                                        </div>
                                                                     </div>
                                                                 </div>
                                                             </div> -->
                                                        <div class="reply-list-box"
                                                            v-for="(thread, index) in emailThread" :key="index">
                                                            <div class="reply-list-img">
                                                                <img src="@/assets/images/admin-img/demo-img/logo.png"
                                                                    alt="" />
                                                            </div>
                                                            <div class="reply-list-content">
                                                                <strong>Subject : {{ thread.subject }} <span
                                                                        v-b-tooltip.up
                                                                        :title="formatDate(thread.Created_at)"
                                                                        data-bs-toggle="tooltip">
                                                                        {{ thread.relativeEmailPostDate
                                                                        }}</span></strong>
                                                                <div class="mail-text-row">
                                                                    <label>Hi {{ thread.candidateName }}</label>
                                                                    <div class="mail-text-desc">
                                                                        <p v-html="thread.emailContent"></p>
                                                                    </div>
                                                                </div>
                                                                <!-- <div class="mail-actions">
                                                                    <div class="attachment-box">
                                                                        <i>
                                                                            <img src="@/assets/images/admin-img/pdf-icon.svg"
                                                                                alt="" class="mCS_img_loaded">
                                                                        </i>
                                                                        <div class="attachment-info">
                                                                            <span>Attachment.pdf</span>
                                                                            <span>20mb</span>
                                                                        </div>
                                                                        <button class="attachmentDownloadBtn">
                                                                            <img src="@/assets/images/admin-img/download-icon.svg"
                                                                                alt="" class="mCS_img_loaded">
                                                                        </button>
                                                                    </div>
                                                                    <ul class="mail-ul-actions">

                                                                        <li>
                                                                            <button id="replyMailBtn"
                                                                                data-bs-toggle="modal"
                                                                                data-bs-target="#replyPop">
                                                                                {{ constants.REPLY_BUTTON }}</button>
                                                                        </li>
                                                                    </ul>
                                                                </div> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div class="admin-pagination-section">
                                <div class="custom-row">
                                    <div class="item-show-selectbox">
                                        <select id="paginationSelectBox" v-model="limit" @change="handleLimitChange">
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                        <span> {{ constants.ENTRIES_PER_PAGE_LABEL }}
                                        </span>
                                    </div>
                                    <div class="admin-pagination" id="paginationBox" v-if="totalPages > 1">
                                        <ul>
                                            <li v-if="currentPage !== 1" @click="changePage(currentPage - 1)">
                                                <a href="#" class="pagination-previous"></a>
                                            </li>
                                            <li v-for="page in visiblePages" :key="page" @click="changePage(page)"
                                                v-if="totalPages != 1">
                                                <a href="#" :class="{ active: currentPage === page }">{{ page }}</a>
                                            </li>
                                            <li v-if="currentPage !== totalPages" @click="changePage(currentPage + 1)">
                                                <a href="#" class="pagination-next"></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <p>No data to display</p>
                        </div>
                    </div>
                </section>
            </div>
        </section>
        <footer class="admin-site-footer">
            <div class="container">
                {{ constants.COPYRIGHT_TEXT }}
            </div>
        </footer>
        <div class="modal fade confirmation-popup" id="deletePop" tabindex="-1" role="dialog"
            aria-labelledby="deleteModalLabel" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="confirmation-popup-icon">
                        <i><img src="@/assets/images/admin-img/light_delete-outline.svg" alt="" /></i>
                    </div>
                    <div class="confirmation-popup-mid">
                        <p>{{ constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT }}</p>
                    </div>
                    <div class="confirmation-popup-btm">
                        <button id="popNoBtn" class="admin-btn-outline-secondary" data-bs-dismiss="modal">
                            {{ constants.NO_BUTTON }}
                        </button>
                        <button id="popYesBtn" class="admin-btn-outline-primary" data-bs-dismiss="modal"
                            @click="confirmDelete">
                            {{ constants.YES_BUTTON }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-------------------------- Delete Pop End --------------------------------->

        <!-------------------------- followupPop Pop Start --------------------------------->

        <div class="modal fade confirmation-popup" id="followupPop" tabindex="-1" role="dialog"
            aria-labelledby="followupModalLabel" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog" role="document">
                <div class="modal-content followupPop">
                    <div class="confirmation-popup-icon">
                        <i><img src="@/assets/images/admin-img/light_w-outline.svg" alt="" /></i>
                    </div>
                    <div class="confirmation-popup-mid">
                        Are you sure, you want to follow up this?
                    </div>
                    <div class="confirmation-popup-btm">
                        <button id="popNoBtn" class="admin-btn-outline-secondary" data-bs-dismiss="modal">
                            {{ constants.NO_BUTTON }}
                        </button>
                        <button id="popYesBtn" class="admin-btn-outline-primary" data-bs-dismiss="modal"
                            @click="confirmStatusChange">
                            {{ constants.YES_BUTTON }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-------------------------- followupPop Pop End --------------------------------->


        <!-------------------------- HiredPop Pop Start --------------------------------->

        <div class="modal fade confirmation-popup" id="HiredPop" tabindex="-1" role="dialog"
            aria-labelledby="HiredModalLabel" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog" role="document">
                <div class="modal-content HiredPop">
                    <div class="confirmation-popup-icon">
                        <i><img src="@/assets/images/admin-img/hired.svg" alt="" /></i>
                    </div>
                    <div class="confirmation-popup-mid">
                        Are you sure, you want to hire this?
                    </div>
                    <div class="confirmation-popup-btm">
                        <button id="popNoBtn" class="admin-btn-outline-secondary" data-bs-dismiss="modal">
                            {{ constants.NO_BUTTON }}
                        </button>
                        <button id="popYesBtn" class="admin-btn-outline-primary" data-bs-dismiss="modal"
                            @click="confirmStatusChange">
                            {{ constants.YES_BUTTON }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-------------------------- HiredPop Pop End --------------------------------->

        <!-------------------------- rejectedPop Pop Start --------------------------------->

        <div class="modal fade confirmation-popup" id="rejectedPop" tabindex="-1" role="dialog"
            aria-labelledby="rejectedModalLabel" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog" role="document">
                <div class="modal-content rejectedPop">
                    <div class="confirmation-popup-icon">
                        <i><img src="@/assets/images/admin-img/reject.svg" alt="" /></i>
                    </div>
                    <div class="confirmation-popup-mid">
                        Are you sure, you want to rejected this?
                    </div>
                    <div class="confirmation-popup-btm">
                        <button id="popNoBtn" class="admin-btn-outline-secondary" data-bs-dismiss="modal">
                            {{ constants.NO_BUTTON }}
                        </button>
                        <button id="popYesBtn" class="admin-btn-outline-primary" data-bs-dismiss="modal"
                            @click="confirmStatusChange">
                            {{ constants.YES_BUTTON }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-------------------------- rejectedPop Pop End --------------------------------->

        <!-------------------------- Reply Pop Start --------------------------------->

        <div class="modal fade reply-popup" id="replyPop" tabindex="-1" role="dialog" aria-labelledby="replyModalLabel"
            aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <button class="reply-pop-close" data-bs-dismiss="modal" id="replyPopCloseBtn"><img
                            src="@/assets/images/admin-img/tags-close-icon.svg" alt="" /></button>
                    <h2>Reply to {{ editJoinTeamData.candidateName }}</h2>
                    <div class="reply-form">
                        <form id="emailReplyForm" @submit.prevent="submitForm">
                            <div class="admin-input-field">
                                <label>
                                    {{ constants.NAME_LABEL }}
                                </label>
                                <input id="replyNameInput" type="text" placeholder="Enter the Name"
                                    v-model="editJoinTeamData.candidateName">
                            </div>
                            <div class="admin-input-field">
                                <label>
                                    {{ constants.EMAIL_LABEL }}
                                </label>
                                <input id="replyNameInput" type="text" placeholder="Enter the Email"
                                    v-model="editJoinTeamData.email">
                            </div>
                            <div class="admin-input-field">
                                <label>
                                    {{ constants.SUBJECT_LABEL }}
                                </label>
                                <input id="replyNameInput" type="text" placeholder="Enter the Subject"
                                    v-model="newEmail.subject">
                                <div class="error-msg" v-if="!newEmail.subject">{{ errMsg }}</div>
                            </div>
                            <div class="admin-input-field">
                                <label>
                                    {{ constants.DESCRIPTION_LABEL }}
                                </label>
                                <!-- <div class="text-editer" id="replyDescInput"> -->
                                <ckeditor placeholder="Description" class="text-editer" id="replyDescInput"
                                    :editor="editor" v-model="newEmail.description" :config="editorConfig"></ckeditor>
                                <!-- </div> -->
                                <div class="error-msg" v-if="!newEmail.description">{{ errMsg }}</div>
                            </div>
                            <div class="admin-input-field-submit">
                                <button id="servicesPgSubmitBtn" type="submit" class="admin-btn-outline-primary">
                                    {{ constants.SUBMIT_BUTTON }}
                                </button>
                                <button type="button" class="dummy-btn" data-bs-dismiss="modal" ref="dummyButton"
                                    style="display: none;"></button>
                                <button id="servicesPgSubmitBtn" type="button" class="admin-btn-outline-secondary"
                                    data-bs-dismiss="modal" @click.prevent="resetForm">
                                    {{ constants.CANCEL_BUTTON }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-------------------------- Reply Pop End --------------------------------->
    </section>
</template>
<script lang="ts">
import { defineComponent, ref,nextTick } from 'vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import constants from "@/utils/en-US-Admin.json";
import adminHeader from "@/components/adminHeader.vue";
import adminNavigation from "@/components/adminNavigation.vue";
import axios from 'axios';
import { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import Swal from 'sweetalert2';
import SimpleBar from 'simplebar';
import { vBTooltip } from 'bootstrap-vue-3';
import Tooltip from 'bootstrap/js/dist/tooltip';
import moment from 'moment';
import { Modal } from 'bootstrap';
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { environment } from '@/config/environment';
import { API_BASE_URL } from '@/config/api.config';
import Sortable, { SortableEvent } from 'sortablejs';



interface JoinTeam {
    id: number;
    candidateName: string;
    email: string;
    designation: string;
    description: string;
    candidateImage: string;
    candidateResume: string;
    nameOfReference: string;
    Created_at: string;
    resumeSize: number;
    resumeName: string;
    status: number;
    editing?: boolean;
    relativePostDate?: string;
    position: number; // Added for drag-and-drop ordering
}

interface EmailThread {
    Created_at: string;
    Updated_at: string;
    candidateId: number;
    candidateName: string;
    email: string;
    emailContent: string;
    id: number;
    status: number;
    subject: string;
    relativeEmailPostDate?: string;
}


export default defineComponent({
    name: "Join-Team",
    directives: {
        'b-tooltip': vBTooltip
    },
    data() {
        return {
            candidateId: 0,
            constants,
            isCustomDateVisible: false,
            tooltips: [] as Tooltip[],
            errMsg: '',
            errEditMsg: '',
            editor: ClassicEditor,
            activeTab: 'all',
            imageSrc: '',
            pendingStatus: '',
            searchTempVar: '',
            editimageSrc: '',
            showAddForm: false,
            limit: 10,
            selectedFile: null as File | null,
            selectedEditFile: null as File | null,
            imageUploaded: false,
            selectAll: false,
            editFormSubmitted: false,
            joinTeams: [] as JoinTeam[],
            editJoinTeamsData: [] as JoinTeam[],
            selectedJoinTeams: [] as number[],
            totalPages: 0,
            currentPage: 1,
            searchedText: '',
            personIdNumber: 0,
            dateFilter: '',
            emailThread: [] as EmailThread[],
            counts: {
                all: 0,
                newApplication: 0,
                followUp: 0,
                rejected: 0,
                hired: 0
            } as any,
            editorConfig: {
                toolbar: {
                    items: [
                        'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'outdent', 'indent', '|', 'undo', 'redo', '|', 'insertTable',
                    ]
                },
            },
            editJoinTeamData: {
                candidateName: '',
                email: '',
                designation: '',
                description: '',
                candidateImage: '',
                nameOfReference: ''
            },
            newEmail: {
                subject: '',
                description: ''
            },
            joinTeamToDelete: null as number | null,
            joinTeamToDownload: null as number | null,
            deleteMode: 'all' as 'all' | 'single',
            downloadMode: 'all' as 'all' | 'single',
            showCustomPicker: false,
            showDateDropdown: false,
            showCustomDate: false,
            startDate: '',
            endDate: '',
            isDragging: false, // Added for drag state
            sortableInstance: null as Sortable | null, // Added for SortableJS instance
            selectedJoinTeam: null as number | null // Track dragged item
        };
    },

    beforeRouteEnter(
        to: RouteLocationNormalized,
        from: RouteLocationNormalized,
        next: NavigationGuardNext
    ) {
        const isLoggedIn = localStorage.getItem('isLoggedIn');
        if (isLoggedIn !== "true") {
            next({ name: 'Login' });
        } else {
            next();
        }
    },
    computed: {
        visiblePages() {
            const maxVisiblePages = 5;
            const halfMaxVisiblePages = Math.floor(maxVisiblePages / 2);
            let start = Math.max(this.currentPage - halfMaxVisiblePages, 1);
            let end = start + maxVisiblePages - 1;

            if (end > this.totalPages) {
                end = this.totalPages;
                start = Math.max(end - maxVisiblePages + 1, 1);
            }

            return Array.from({ length: end - start + 1 }, (_, i) => start + i);
        },
        getStatusColor() {
            return (status: any) => {
                switch (status) {
                    case 0:
                        return { borderColor: '#946CCF', color: '#946CCF' };
                    case 1:
                        return { borderColor: '#FDA900', color: '#FDA900' };
                    case 3:
                        return { borderColor: '#5BC770', color: '#5BC770' };
                    case 4:
                        return { borderColor: 'red', color: 'red' };
                    default:
                        return { borderColor: '#946CCF', color: '#946CCF' };
                }
            };
        }
    },
    components: {
        adminHeader,
        adminNavigation,
        Datepicker
    },
    created() {
        this.fetchCounts();
        this.fetchJoinTeams()
    },
    mounted() {
        const el = this.$refs.scrollWrapper as HTMLElement;
        if (el) {
            new SimpleBar(el);
        };
        this.initializeTooltips();
        this.setupSortable(); // Initialize SortableJS on mount
    },
    methods: {
        handleDate() {
            this.dateFilter = 'custom'
            this.fetchJoinTeams(this.activeTab)
            this.fetchCounts()
            this.resetClasses()
        },
        onRangeStart(value: any) {
            const d = new Date(value);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            this.startDate = `${year}-${month}-${day}`

        },
        onRangeEnd(value: any) {
            const d = new Date(value);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            this.endDate = `${year}-${month}-${day}`

        },
        resetClasses() {
            this.showCustomPicker = false;
            this.showDateDropdown = false;
            this.showCustomDate = false;
        },
        formatCustomDate(date: any) {
            const [year, month, day] = date.split('-');
            return `${day}/${month}/${year}`;
        },
        async getDateFilteredData(dateFilter: any) {
            this.dateFilter = dateFilter
            this.fetchJoinTeams(this.activeTab);
            this.fetchCounts()
        },
        async fetchJoinTeams(status = 'all', limit?: number, skip = 0, sortBy = 'position') {
    // Use this.limit as the default value if limit is not provided
        const effectiveLimit = limit ?? this.limit;

        let url = `${API_BASE_URL}/candidates/`;
        const params = new URLSearchParams();
        if (status === 'newApplication') params.append('status', '0');
        else if (status === 'followUp') params.append('status', '1');
        else if (status === 'rejected') params.append('status', '4');
        else if (status === 'hired') params.append('status', '3');
        if (this.searchedText) {
            if (!this.searchTempVar) {
                this.limit = 10;
                this.currentPage = 1;
            }
            this.searchTempVar = this.searchedText;
        }
        if (!this.searchedText) {
            if (this.searchTempVar) {
                this.currentPage = 1;
                this.limit = 10;
                this.searchTempVar = '';
            }
            params.append('limit', effectiveLimit.toString());
            const skipArticle = (this.currentPage - 1) * effectiveLimit;
            params.append('skip', skipArticle.toString());
        }
        if (this.searchedText) {
            params.append('limit', effectiveLimit.toString());
            params.append('skip', skip.toString());
            params.append('searchedText', this.searchedText);
        }
        if (this.dateFilter) {
            params.append('dateFilter', this.dateFilter);
            if (this.dateFilter === 'custom') {
                params.append('startDate', this.startDate);
                params.append('endDate', this.endDate);
            }
        }
        params.append('sort_by', sortBy);

        try {
            const response = await axios.get(`${url}?${params.toString()}`);
            this.editJoinTeamsData = response.data.map((joinTeam: { Created_at: moment.MomentInput }) => {
                return {
                    ...joinTeam,
                    relativePostDate: moment(joinTeam.Created_at).fromNow()
                };
            });
            this.setupSortable(); // Reinitialize SortableJS after data fetch
        } catch (error) {
            console.error('Error fetching joinTeams:', error);
        }
    },
    async submitForm() {
    if (!this.newEmail.subject || !this.newEmail.description) {
        this.errMsg = 'Please Enter Essential Fields.';
        return;
    }
    try {
        const data = {
            candidateName: this.editJoinTeamData.candidateName,
            email: this.editJoinTeamData.email,
            subject: this.newEmail.subject,
            emailContent: this.newEmail.description,
            candidateId: this.candidateId
        };
        const response = await fetch(`${API_BASE_URL}/candidates-email-threads/send_email/`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify(data)
        });
        await response.json();
        this.resetForm();
        this.errMsg = '';
        (this.$refs.dummyButton as HTMLElement).click();
        Swal.fire({
            icon: 'success',
            title: 'Email Sent Successfully!',
            showConfirmButton: false,
            timer: 1500
        });
        await this.fetchEmailThreads(this.candidateId, this.editJoinTeamData.email);
        // Refresh the candidate list to ensure pagination is maintained
        await this.fetchJoinTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
    } catch (error) {
        console.error('Error submitting article:', error);
    }
},
        async fetchEmailThreads(candidateId: number, email: string) {
            try {
                const response = await fetch(`${API_BASE_URL}/candidates-email-threads/?candidateId=${candidateId}&email=${email}`);
                const data = await response.json();
                this.emailThread = data.map((emailThreads: { Created_at: moment.MomentInput; }) => {
                    return {
                        ...emailThreads,
                        relativeEmailPostDate: moment(emailThreads.Created_at).fromNow()
                    };
                });

            } catch (error) {
                console.error(error)

            }

        },
        dummyfunction(index: any, id: any, email: any) {
            this.editJoinTeam(index),
                this.fetchEmailThreads(id, email)
        },

        personId(id: number) {
            this.personIdNumber = id

        },
        onStatusChange(event: Event) {
            const selectBox = event.target as HTMLSelectElement;
            this.pendingStatus = selectBox.value;
            let modalId = '';
            switch (this.pendingStatus) {
                case 'followup':
                    modalId = 'followupPop';
                    break;
                case 'hired':
                    modalId = 'HiredPop';
                    break;
                case 'rejected':
                    modalId = 'rejectedPop';
                    break;
            }
            if (modalId) {
                const modalElement = document.getElementById(modalId);
                if (modalElement) {
                    const modalInstance = new Modal(modalElement);
                    modalInstance.show();
                }
            } else {
                this.updateStatusStyle(this.pendingStatus);
            }
        },

        updateStatusStyle(status: any) {
            const selectBox = document.getElementById("statusSelectBox");
            if (status === 'new') {
                this.confirmStatusChange();
            }
            if (selectBox) {
                switch (status) {
                    case 'new':
                        selectBox.style.borderColor = '#946CCF';
                        selectBox.style.color = '#946CCF';
                        break;
                    case 'followup':
                        selectBox.style.borderColor = '#FDA900';
                        selectBox.style.color = '#FDA900';
                        break;
                    case 'hired':
                        selectBox.style.borderColor = '#5BC770';
                        selectBox.style.color = '#5BC770';
                        break;
                    case 'rejected':
                        selectBox.style.borderColor = 'red';
                        selectBox.style.color = 'red';
                        break;
                }
            }
        },

        async confirmStatusChange() {
        const updatedStatus = this.pendingStatus;
        let statusValue = 0;
        if (updatedStatus === 'followup' || updatedStatus === 'hired' || updatedStatus === 'rejected') {
            this.updateStatusStyle(updatedStatus);
        }
        if (updatedStatus === 'new') { statusValue = 0; }
        else if (updatedStatus === 'followup') { statusValue = 1; }
        else if (updatedStatus === 'hired') { statusValue = 3; }
        else if (updatedStatus === 'rejected') { statusValue = 4; }
        try {
            const formData = new FormData();
            formData.append('status', statusValue.toString());
            await axios.patch(`${API_BASE_URL}/candidates/${this.personIdNumber}/`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            await this.fetchJoinTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
            if (this.editJoinTeamsData.length === 0 && this.currentPage > 1) {
                this.currentPage--;
                await this.fetchJoinTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
            }
            this.fetchCounts();
        } catch (error) {
            console.error('Error updating joinTeam status:', error);
        }
        this.pendingStatus = '';
    },
        initializeTooltips() {
            const tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
            tooltipElements.forEach((element) => {
                const tooltip = new Tooltip(element);
                this.tooltips.push(tooltip);
            });
        },
        
        formatDate(date: any) {
        const pastDate = moment.utc(date).local();
        const now = moment();
        const secondsDiff = now.diff(pastDate, 'seconds');
        const minutesDiff = now.diff(pastDate, 'minutes');
        const hoursDiff = now.diff(pastDate, 'hours');
        const daysDiff = now.diff(pastDate, 'days');
        const weeksDiff = Math.floor(daysDiff / 7);
        const monthsDiff = now.diff(pastDate, 'months');
        const yearsDiff = now.diff(pastDate, 'years');
        console.log(daysDiff);


        if (secondsDiff < 60) {
            return `${secondsDiff} second${secondsDiff !== 1 ? 's' : ''} ago`;
        } else if (minutesDiff < 60) {
            return `${minutesDiff} minute${minutesDiff !== 1 ? 's' : ''} ago`;
        } else if (hoursDiff < 24) {
            return `${hoursDiff} hour${hoursDiff !== 1 ? 's' : ''} ago`;
        } else if (daysDiff < 7) {
            return `${daysDiff} day${daysDiff !== 1 ? 's' : ''} ago`;
        } else if (daysDiff < 30) {
            return `${weeksDiff} week${weeksDiff !== 1 ? 's' : ''} ago`; // 7–29 days
        } else if (daysDiff < 365) {
            return `${monthsDiff} month${monthsDiff !== 1 ? 's' : ''} ago`;
        } else {
            return `${yearsDiff} year${yearsDiff !== 1 ? 's' : ''} ago`;
        }
    
        },
        setDeleteMode(mode: any, joinTeamId?: number) {
            this.deleteMode = mode;
            if (joinTeamId !== undefined) {
                this.joinTeamToDelete = joinTeamId;
            }
        },
        downloadResume(mode: any, joinTeamId?: number, joinTeamName?: string) {
            this.downloadMode = mode;
            if (joinTeamId !== undefined) {
                this.joinTeamToDownload = joinTeamId;
            }
            this.confirmDownload(joinTeamName);
        },
        confirmDownload(joinTeamName?: string) {
            if (this.downloadMode === 'all') {
                this.downloadSelectedContacts();
            } else if (this.downloadMode === 'single') {
                this.downloadJoinTeam(joinTeamName);
            }
        },
        confirmDelete() {
            if (this.deleteMode === 'all') {
                this.deleteSelectedContacts();
            } else if (this.deleteMode === 'single') {
                this.deleteJoinTeam();
            }
        },
        changePage(page: number) {
            if (page > 0 && page <= this.totalPages) {
                this.currentPage = page;
                this.fetchJoinTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
                this.selectAll = false
                this.selectedJoinTeams = []
            }
        },
        toggleJoinTeamSelection(joinTeamId: number) {
            if (this.selectedJoinTeams.includes(joinTeamId)) {
                this.selectedJoinTeams = this.selectedJoinTeams.filter(id => id !== joinTeamId);
            } else {
                this.selectedJoinTeams.push(joinTeamId);
            }


        },
        toggleSelectAll() {
            if (this.selectAll === true) {
                this.selectedJoinTeams = [];
                this.selectAll = false
            } else {
                this.selectedJoinTeams = this.editJoinTeamsData.map(joinTeam => joinTeam.id);
                this.selectAll = true
            }
        },

        async deleteSelectedContacts() {
            try {
                await axios.delete(`${API_BASE_URL}/candidates/bulk_delete/`, { data: { ids: this.selectedJoinTeams } });
                this.editJoinTeamsData = this.editJoinTeamsData.filter(joinTeam => !this.selectedJoinTeams.includes(joinTeam.id));
                this.selectedJoinTeams = [];
                this.fetchJoinTeams()
                if (this.editJoinTeamsData.length === 0) {
                    this.currentPage = this.currentPage - 1;
                    if (this.currentPage < 1) {
                        this.currentPage = 1;
                    }
                    this.fetchJoinTeams(this.activeTab);
                    this.selectAll = false
                    this.fetchCounts()
                }
            } catch (error) {
                console.error('Error deleting contacts:', error);
            }
        },
        async downloadSelectedContacts() {
        try {
            const response = await axios.post(`${API_BASE_URL}/candidates/download-resumes/`, {
                ids: this.selectedJoinTeams
            }, {
                responseType: 'arraybuffer'
            });
            const blob = new Blob([response.data], { type: 'application/zip' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'candidate_resumes.zip';
            link.click();
            this.editJoinTeamsData = this.editJoinTeamsData.filter(joinTeam => !this.selectedJoinTeams.includes(joinTeam.id));
            this.selectedJoinTeams = [];
            await this.fetchJoinTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
            this.fetchCounts();
            this.selectAll = false;
        } catch (error) {
            console.error('Error downloading selected contacts:', error);
        }
    },

        handleLimitChange() {
            this.currentPage = 1;
            this.totalPages = Math.ceil(this.counts[this.activeTab] / this.limit);
            this.selectAll = false
            this.selectedJoinTeams = [];
            this.fetchJoinTeams(this.activeTab, this.limit);
        },

        async switchView(status: string) {
            this.currentPage = 1;
            this.activeTab = status;
            this.selectedJoinTeams = [];
            this.selectAll = false
            this.editFormSubmitted = false;
            await this.fetchJoinTeams(status);
            this.limit = 10
            if (status === 'newApplication') {
                this.totalPages = Math.ceil(this.counts.newApplication / this.limit);
            } else if (status === 'followUp') {
                this.totalPages = Math.ceil(this.counts.followUp / this.limit);
            } else if (status === 'rejected') {
                this.totalPages = Math.ceil(this.counts.rejected / this.limit);
            } else if (status === 'hired') {
                this.totalPages = Math.ceil(this.counts.hired / this.limit);
            } else {
                this.totalPages = Math.ceil(this.counts.all / this.limit);
            }
        },
        async fetchCounts(searchedText?: string) {
            try {
                const baseUrl = `${API_BASE_URL}/candidates/count/`;
                const queryParam = searchedText ? `?searchedText=${searchedText}&status=` : '?status=';
                let dateFilterParam = '';
                if (this.dateFilter) {
                    if (this.dateFilter === 'custom' && this.startDate && this.endDate) {
                        dateFilterParam = `&dateFilter=custom&startDate=${this.startDate}&endDate=${this.endDate}`;
                    } else {
                        dateFilterParam = `&dateFilter=${this.dateFilter}`;
                    }
                }
                //     if(this.dateFilter==='custom'){

                // }
                //     const dateFilterParam = this.dateFilter ? `&dateFilter=${this.dateFilter}` : '';
                const [allResponse, newApplicationResponse, followUpResponse, rejectedResponse, hiredResponse] = await Promise.all([
                    axios.get(`${baseUrl}${queryParam}0&status=1&status=0&status=4&status=3${dateFilterParam}`),
                    axios.get(`${baseUrl}${queryParam}0${dateFilterParam}`),
                    axios.get(`${baseUrl}${queryParam}1${dateFilterParam}`),
                    axios.get(`${baseUrl}${queryParam}4${dateFilterParam}`),
                    axios.get(`${baseUrl}${queryParam}3${dateFilterParam}`)
                ]);

                this.counts = {
                    all: allResponse.data.count,
                    newApplication: newApplicationResponse.data.count,
                    followUp: followUpResponse.data.count,
                    rejected: rejectedResponse.data.count,
                    hired: hiredResponse.data.count
                };

                if (this.activeTab in this.counts) {
                    this.totalPages = Math.ceil(this.counts[this.activeTab] / 10);
                } else {
                    console.error(`Invalid active tab: ${this.activeTab}`);
                }
            } catch (error) {
                console.error('Error fetching joinTeam counts:', error);
            }
        },


        editJoinTeam(index: number) {
            this.editJoinTeamsData.forEach((joinTeam, i) => {
                joinTeam.editing = i === index;
            });
            this.editFormSubmitted = true;
            const selectedJoinTeam = this.editJoinTeamsData[index];
            this.editJoinTeamData = {
                candidateName: selectedJoinTeam.candidateName,
                description: selectedJoinTeam.description,
                email: selectedJoinTeam.email,
                designation: selectedJoinTeam.designation,
                nameOfReference: selectedJoinTeam.nameOfReference,
                candidateImage: selectedJoinTeam.candidateImage || ''
            };
            // Use getCdnImageAddress to ensure proper CDN URL
            this.editimageSrc = selectedJoinTeam.candidateImage
                ? this.getCdnImageAddress(selectedJoinTeam.candidateImage, 'w_160,h_160/')
            : '';
            // Disable SortableJS when editing
            if (this.sortableInstance) {
                this.sortableInstance.option('disabled', true);
            }
        },

        async deleteJoinTeam() {
        try {
            await axios.delete(`${API_BASE_URL}/candidates/${this.joinTeamToDelete}/`);
            this.editFormSubmitted = false;
            await this.fetchJoinTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
            this.fetchCounts();
            (this.$refs.dummyButton as HTMLElement).click();
        } catch (error) {
            console.error('Error deleting joinTeam:', error);
        }
    },
    async downloadJoinTeam(joinTeamName?: string) {
        try {
            const response = await axios.post(`${API_BASE_URL}/candidates/download-resumes/`, {
                ids: [this.joinTeamToDownload]
            }, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `${joinTeamName}.pdf`;
            link.click();
            await this.fetchJoinTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        } catch (error) {
            console.error('Error downloading joinTeam:', error);
        }
    },
        getCdnImageAddress(src: string, size: string): string {
            if (!src) return '';
            let cdnUrl: string = environment.imageCdn.getHost;
            cdnUrl = cdnUrl.concat(size);
            return cdnUrl + encodeURIComponent(src);
        },
        async resetForm() {
            this.newEmail.subject = '';
            this.newEmail.description = ''
            // Re-enable SortableJS after resetting form if needed
            if (this.sortableInstance) {
                this.sortableInstance.option('disabled', false);
            }
        },
        setupSortable() {
            nextTick(() => {
                const sortableList = this.$refs.sortableList as HTMLElement;
                if (!sortableList) {
                    console.error('Sortable list ref not found!');
                    return;
                }

                if (this.sortableInstance) {
                    this.sortableInstance.destroy();
                }

                this.sortableInstance = Sortable.create(sortableList, {
                    animation: 150,
                    draggable: '.admin-item-box',
                    ghostClass: 'sortable-ghost',
                    chosenClass: 'sortable-chosen',
                    dragClass: 'sortable-drag',
                    filter: '.css-checkbox, button, input, textarea, a, .ck-editor, .ck-content', // Prevent dragging on interactive elements
                    preventOnFilter: true,
                    disabled: this.editFormSubmitted, // Disable dragging when editing
                    onStart: (evt: SortableEvent) => {
                        this.isDragging = true;
                        this.selectedJoinTeam = this.editJoinTeamsData[evt.oldIndex!].id;
                    },
                    onEnd: async (evt: SortableEvent) => {
                        this.isDragging = false;
                        this.selectedJoinTeam = null;
                        const oldIndex = evt.oldIndex!;
                        const newIndex = evt.newIndex!;

                        if (oldIndex === newIndex) return;

                        // Optimistically update local data
                        const newJoinTeamsData = [...this.editJoinTeamsData];
                        const [movedItem] = newJoinTeamsData.splice(oldIndex, 1);
                        newJoinTeamsData.splice(newIndex, 0, movedItem);

                        // Update positions locally
                        newJoinTeamsData.forEach((item, index) => {
                            item.position = index + 1; // 1-based positioning
                        });

                        // Update reactive property
                        this.editJoinTeamsData = newJoinTeamsData;

                        // Prepare data for backend sync
                        const reorderedItems = newJoinTeamsData.map((item) => ({
                            id: item.id,
                            position: item.position,
                        }));

                        try {
                            await axios.post(`${API_BASE_URL}/candidates/reorder/`, {
                                items: reorderedItems,
                            });

                            // Fetch updated data from server
                            await this.fetchJoinTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);

                            Swal.fire({
                                icon: 'success',
                                title: 'Order Updated Successfully!',
                                timer: 1500,
                                showConfirmButton: false,
                            });
                        } catch (error) {
                            console.error('Error updating order:', error);
                            await this.fetchJoinTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
                            Swal.fire({
                                icon: 'error',
                                title: 'Order Update Failed!',
                                text: 'Reverted to last saved order.',
                                showConfirmButton: false,
                                timer: 1500,
                            });
                        }
                    },
                });

                console.log('Sortable instance created:', this.sortableInstance);
            });
        },
        // Override cancel edit behavior to re-enable dragging
        editJoinTeamCancel() { // Add this method if you want a cancel button in the edit form
            this.editJoinTeamsData.forEach((joinTeam) => {
                joinTeam.editing = false;
            });
            this.editFormSubmitted = false;
            if (this.sortableInstance) {
                this.sortableInstance.option('disabled', false);
            }
        },
    }
});
</script>
<style scoped>
.admin-item-box-top {
  cursor: move;
}
.admin-item-box.dragging {
  opacity: 0.5;
}
</style>